import { ActionResponse } from 'src/app/models/action-response';

export interface State {
  bulkSearchStep: any[];
  response: ActionResponse;
  errorMessage: string;
}

export const initialState: State = {
  bulkSearchStep: null,
  response: null,
  errorMessage: null,
};
